import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/ui';
import {
  BulkJobCards,
  DesignEntryChoice,
  DesignsTable,
} from '@/components/designs';

/**
 * Start page of the seller area (docs/design/seller-area/Main.dc.html and
 * DesignsEmpty.dc.html): header, the two ways into the Creator, then the
 * designs last edited. Bulk runs show their progress cards between the
 * entry tiles and the grid. Rendered inside the SellerShell at `/designs`.
 */
export function DesignsPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex w-full max-w-[1216px] flex-col">
      <PageHeader
        eyebrow={t('seller.designs.eyebrow')}
        title={t('seller.designs.title')}
        className="mb-7"
      />
      <DesignEntryChoice className="mb-9" />
      <BulkJobCards className="mb-9" />
      <DesignsTable />
    </div>
  );
}
